export default "__VITE_ASSET__6327649d__"